import { Alert, Text, VFlow } from 'bold-ui'

export interface ValidationErrors {
  rndsError?: string
  cadsusError?: string
  pdmError?: string
  sinanError?: string
}

interface ValidacaoServicosErrorAlertProps {
  error: ValidationErrors
}

export function ValidacaoServicosErrorAlert({ error }: Readonly<ValidacaoServicosErrorAlertProps>) {
  const mensagens = [error.rndsError, error.cadsusError, error.pdmError, error.sinanError].filter(
    (mensagem) => !!mensagem
  )
  const mensagensDistintas = Array.from(new Set(mensagens))

  return (
    <Alert type='danger' inline>
      <VFlow vSpacing={0}>
        {mensagensDistintas.map((mensagem) => (
          <Text key={mensagem}>{mensagem}</Text>
        ))}
      </VFlow>
    </Alert>
  )
}
